import { EditTab } from '@/features/events/components/Detail/Tabs/EditTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/edit')({
  component: EditTab,
});
